import FpSdk from 'forepaas/sdk';
import MemoryActions from 'forepaas/store/memory/action';
import SessionActions from 'forepaas/store/session/action';
import authService from '../services/auth-service';
import { validateAuthMethod } from './auth-method-validator';
import { showAuthMethodError } from './auth-method-validator';

export const signOut = async (showGoodbyeScreen = true) => {
  showGoodbyeScreen && sessionStorage.setItem('show_goodbye_screen', JSON.stringify(true));
  return await authService.signOut().then(result => {
    localStorage.clear();
    sessionStorage.clear();
    showGoodbyeScreen && FpSdk.modules.store.dispatch(SessionActions.set('show_goodbye_screen', true));
    FpSdk.modules.store.dispatch(MemoryActions.del('user'));
    return result;
  });
}

/**
 * Local-only sign out that clears app state without calling Auth.signOut().
 * Used when we need to show an error dialog without triggering SSO logout redirect.
 */
export const signOutLocal = () => {
  localStorage.clear();
  sessionStorage.clear();
  FpSdk.modules.store.dispatch(SessionActions.set('show_goodbye_screen', true));
  FpSdk.modules.store.dispatch(MemoryActions.del('user'));
}

export const refreshCurrentUser = async () => {
  return authService.currentUser({ bypassCacheUserInfo: true })
    .then(async user => {
      if (user) {
        // Validate authentication method before setting user in store
        const isValid = await validateAuthMethod();

        if (!isValid) {
          // Validation failed - use local sign out to avoid SSO redirect
          // This keeps the error dialog visible
          signOutLocal();
          showAuthMethodError();
          return null;
        }

        // Validation passed, set user in store
        FpSdk.modules.store.dispatch(MemoryActions.set('user', user))
      }
      return user
    })
}
